/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { SimplifiedParameterType } from '../models/SimplifiedParameterType';
import { ModelUtils } from '../util/ModelUtils';
import { SimplifiedTypeUtil } from '../util/SimplifiedTypeUtil';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Constants } from '../../core/Constants';
import { Document } from '../../core/models/Document';
import { DocumentType } from '../../core/models/DocumentType';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { IOasParameterParent } from '../../openapi/models/IOasParameterParent';
import { OasOperation } from '../../openapi/models/OasOperation';
import { OasParameter } from '../../openapi/models/OasParameter';
import { OasPathItem } from '../../openapi/models/OasPathItem';
import { Oas20Parameter } from '../../openapi/v2/models/Oas20Parameter';
import { Oas30Schema } from '../../openapi/v3/models/Oas30Schema';

/**
 * A command used to create a new parameter.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class NewParamCommand extends AbstractCommand {
    public _paramName : string;

    public _paramType : string;

    public _parentPath : NodePath;

    public _description : string;

    public _newType : SimplifiedParameterType;

    public _override : boolean;

    public _created : boolean;

    public constructor(parent? : any, paramName? : any, paramType? : any, description? : any, newType? : any, override? : any) {
        if(((parent != null && (parent["__interfaces"] != null && parent["__interfaces"].indexOf("io.apicurio.datamodels.openapi.models.IOasParameterParent") >= 0 || parent.constructor != null && parent.constructor["__interfaces"] != null && parent.constructor["__interfaces"].indexOf("io.apicurio.datamodels.openapi.models.IOasParameterParent") >= 0)) || parent === null) && ((typeof paramName === 'string') || paramName === null) && ((typeof paramType === 'string') || paramType === null) && ((typeof description === 'string') || description === null) && ((newType != null && newType instanceof <any>SimplifiedParameterType) || newType === null) && ((typeof override === 'boolean') || override === null)) {
            let __args = arguments;
            super();
            if(this._paramName===undefined) this._paramName = null;
            if(this._paramType===undefined) this._paramType = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._description===undefined) this._description = null;
            if(this._newType===undefined) this._newType = null;
            if(this._override===undefined) this._override = false;
            if(this._created===undefined) this._created = false;
            if(this._paramName===undefined) this._paramName = null;
            if(this._paramType===undefined) this._paramType = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._description===undefined) this._description = null;
            if(this._newType===undefined) this._newType = null;
            if(this._override===undefined) this._override = false;
            if(this._created===undefined) this._created = false;
            (() => {
                this._parentPath = Library.createNodePath(<Node><any>parent);
                this._paramName = paramName;
                this._paramType = paramType;
                this._description = description;
                this._newType = newType;
                this._override = override;
            })();
        } else if(parent === undefined && paramName === undefined && paramType === undefined && description === undefined && newType === undefined && override === undefined) {
            let __args = arguments;
            super();
            if(this._paramName===undefined) this._paramName = null;
            if(this._paramType===undefined) this._paramType = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._description===undefined) this._description = null;
            if(this._newType===undefined) this._newType = null;
            if(this._override===undefined) this._override = false;
            if(this._created===undefined) this._created = false;
            if(this._paramName===undefined) this._paramName = null;
            if(this._paramType===undefined) this._paramType = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._description===undefined) this._description = null;
            if(this._newType===undefined) this._newType = null;
            if(this._override===undefined) this._override = false;
            if(this._created===undefined) this._created = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewParamCommand] Executing.");
        this._created = false;
        let parent : IOasParameterParent = <IOasParameterParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            LoggerCompat.info("[NewParamCommand] Parent node (operation or path item) is null.");
            return;
        }
        if(this.hasParam(this._paramName, this._paramType, parent)) {
            LoggerCompat.info("[NewParamCommand] Param %s of type %s already exists.", this._paramName, this._paramType);
            return;
        }
        let parameters : Array<OasParameter> = parent.getParameters();
        if(this.isNullOrUndefined(parameters)) {
            parameters = <any>([]);
            NodeCompat.setProperty(parent, Constants.PROP_PARAMETERS, parameters);
        }
        let param : OasParameter = parent.createParameter();
        let configured : boolean = false;
        if(this._override) {
            let oparam : OasParameter = this.findOverridableParam(<OasOperation><any>parent);
            if(ModelUtils.isDefined(oparam)) {
                Library.readNode(Library.writeNode(oparam), param);
                configured = true;
            }
        }
        if(!configured) {
            param.in = this._paramType;
            param.name = this._paramName;
            if(NodeCompat.equals(param.in, "path")) {
                param.required = true;
            }
            if(ModelUtils.isDefined(this._description)) {
                param.description = this._description;
            }
            if(ModelUtils.isDefined(this._newType)) {
                this._setParameterType(param);
            }
        }
        parent.addParameter(param);
        LoggerCompat.info("[NewParamCommand] Param %s of type %s created successfully.", param.name, param.in);
        this._created = true;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewParamCommand] Reverting.");
        if(!this._created) {
            return;
        }
        let parent : IOasParameterParent = <IOasParameterParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let theParam : OasParameter = null;
        let parameters : Array<OasParameter> = parent.getParameters();
        for(let index196=0; index196 < parameters.length; index196++) {
            let param = parameters[index196];
            {
                if(NodeCompat.equals(param.in, this._paramType) && NodeCompat.equals(param.name, this._paramName)) {
                    theParam = param;
                    break;
                }
            }
        }
        if(ModelUtils.isDefined(theParam)) {
            /* remove */parameters.splice(parameters.indexOf(theParam), 1)[0];
            if(/* size */(<number>parameters.length) === 0) {
                NodeCompat.setProperty(parent, Constants.PROP_PARAMETERS, null);
            }
        }
    }

    /**
     * Sets the parameter type.
     * @param {OasParameter} parameter
     */
    _setParameterType(parameter : OasParameter) {
        if(parameter.ownerDocument().getDocumentType() === DocumentType.openapi2) {
            let param : Oas20Parameter = <Oas20Parameter>parameter;
            SimplifiedTypeUtil.setSimplifiedTypeOnParam(param, this._newType);
        } else {
            let schema : Oas30Schema = <Oas30Schema>parameter.createSchema();
            SimplifiedTypeUtil.setSimplifiedType(schema, this._newType);
            parameter.schema = schema;
        }
        let required : boolean = this._newType.required;
        if(NodeCompat.equals(parameter.in, "path")) {
            required = true;
        }
        if(ModelUtils.isDefined(required)) {
            parameter.required = required;
        }
    }

    /**
     * Returns true if the given param already exists in the parent.
     * @param {string} paramName
     * @param {string} paramType
     * @param {*} parent
     * @returns {boolean}
     * @return {boolean}
     * @private
     */
    /*private*/ hasParam(paramName : string, paramType : string, parent : IOasParameterParent) : boolean {
        return ModelUtils.isDefined(parent.getParameter(paramType, paramName));
    }

    /**
     * Tries to find the parameter being overridden (if any).  Returns null if it can't
     * find something.
     * @param {OasOperation} operation
     * @return {OasParameter}
     */
    public findOverridableParam(operation : OasOperation) : OasParameter {
        let rval : OasParameter = null;
        let pathItem : OasPathItem = <OasPathItem>operation.parent();
        if(ModelUtils.isDefined(pathItem)) {
            rval = pathItem.getParameter(this._paramType, this._paramName);
        }
        return rval;
    }
}
NewParamCommand["__class"] = "io.apicurio.datamodels.cmd.commands.NewParamCommand";
NewParamCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




